<template>
    <div>
        <div id="container">
            <div class="card">
                <div class="web-chat-group">
                    <div class="row align-items-center">
                        <div class="col-md-3">
                            <div class="ml-2 mt-1 pl-3 pt-2 pb-3">
                                <span><b>{{ name }}</b></span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="pt-1 pb-1">
                                <p>{{ description }}</p>

                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="pt-1 pb-1">
                                <div v-if="users">
                                    <span v-for="user of users" class="badge badge-pill badge-primary text-wrap"><small>{{ user.name }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mt-1 float-right">
                                <button class="btn btn-default btn-icon ml-1" title="Duplicate" @click="replicate">
                                    <i class="fa fa-fw fa-copy"></i>
                                </button>
                                <button class="btn btn-default btn-icon ml-1" title="Delete" @click="remove">
                                    <i class="fa fa-fw fa-trash"></i>
                                </button>
                                <button class="btn btn-default btn-icon ml-1" title="Edit" @click="openModal">
                                    <i class="fa fa-fw fa-pencil-alt"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            group: {required: true},
        },

        computed: {
            name() {
                return this.group.name;
            },
            description() {
                return this.group.description;
            },
            users() {
                if(this.group.users){
                    if(this.group.users.length > 3){
                        let userList = this.group.users.slice(0, 3);
                        let remainingUsers = this.group.users.length - 3;
                        userList.push({name: '+' + remainingUsers + ''});
                        return userList;
                    }
                    return this.group.users;
                }
                return [];
            }
        },

        methods:{
            openModal() {
                this.$emit('openModal', this.group);
            },

            async remove() {
                const result = await this.$confirmDialog();
                if (!result) return;
                this.$emit('deleteWebChatGroup', this.group);
                swal.close();
            },

            async replicate() {
                await this.$http.get('/webchat-groups/replicate/' + this.group.id);
                this.$emit('replicatedWebChatGroup', this.group);
            }
        }

    }
</script>
<style>
    .web-chat-group {
        border-radius: 0;
        width: 100%;
        max-height: 100px;
        background-color: #ffffff;
    }

    #container {
        margin-bottom: -20px;
    }

    @media screen and (max-width: 991px) {
        #container {
            flex-direction: column;
            align-items: center;
        }

    }
</style>
